import React from 'react';

interface ServiceDescriptionProps {
    description: string;
}

const ServiceDescription = (props: ServiceDescriptionProps) => {
    const { description } = props;
    return (
        <article className='service-content-item__description'>
            {description}
        </article>
    );
};

export default ServiceDescription;
